import { getApplicationLayout } from '../../../shared/api/controllers/applications';
import ApplicationLayoutModel from '../../../shared/models/applications/api/ApplicationLayoutModel';
import { AssistantLaunchRecord } from '../../../shared/models/revenue/AssistantLaunchReport';

export const loadLaunchCalendarLayouts = async (
    records: AssistantLaunchRecord[],
    isCancelled: () => boolean
): Promise<Record<string, ApplicationLayoutModel | null>> => {
    const organizationIds = Array.from(new Set(records.map(record => record.organizationId).filter(Boolean)));
    const layouts: Record<string, ApplicationLayoutModel | null> = {};
    let nextIndex = 0;
    const loadNext = async () => {
        while (nextIndex < organizationIds.length && !isCancelled()) {
            const organizationId = organizationIds[nextIndex++];
            try {
                const result = await getApplicationLayout(organizationId);
                layouts[organizationId] = result.resultType === 'Ok' && result.data ? result.data : null;
            } catch {
                // Group metadata is optional; the calendar remains usable without it.
                layouts[organizationId] = null;
            }
        }
    };
    await Promise.all(Array.from({ length: Math.min(5, organizationIds.length) }, loadNext));
    return layouts;
};
